module.exports = __webpack_public_path__ + "img/CZ24131768.cf76c760.svg";